<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <!-- Global overlay, mounted once. React never mounted CoLoader anywhere,
       so LoadingService.show() had no effect. Toasts need no mount: they are
       presented imperatively through ToastController. -->
  <co-loader />

  <!-- A push that arrives while the app is open; see PushNotificationService. -->
  <co-push-alert />
</ion-app>
